import { render } from "./CPOEnergyConsumedDashboard.vue?vue&type=template&id=388aa8f1&scoped=true"
import script from "./CPOEnergyConsumedDashboard.vue?vue&type=script&lang=js"
export * from "./CPOEnergyConsumedDashboard.vue?vue&type=script&lang=js"

import "./CPOEnergyConsumedDashboard.vue?vue&type=style&index=0&id=388aa8f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388aa8f1"]])

export default __exports__